import { gql } from 'react-apollo';

export const assignmentSubmitMutation = gql`
  mutation assignmentSubmit($assignmentId: String!) {
    submitAssignment(assignmentId: $assignmentId) {
      ok
    }
  }
`;
